<template>
  <v-menu
    v-model="datePickerMenu"
    :disabled="disabled"
    :close-on-content-click="false"
    :nudge-right="40"
    transition="scale-transition"
    offset-y
    min-width="auto"
    >
      <template v-slot:activator="{ on, attrs }">
          <v-text-field
          outlined
          :rules="rules"
          :disabled="disabled"
          v-model="parsedDate"
          :label="label"
          readonly
          v-bind="attrs"
          v-on="on"
          ></v-text-field>
      </template>
      <div>{{value}}</div>
      <v-date-picker
        v-model="date"
        locale="es-MX"
        @input="parseInput"
        :min="min"
      ></v-date-picker>
  </v-menu>
</template>

<script>
import ENV from '../../../env.js'

export default {
  mounted() {
    this.parseInput(this.value)
    this.parseInput(this.default?.substring(0,10) || null)
  },
  methods: {
    parseInput (input) {
      this.date = input
      this.datePickerMenu = false
      if (!this.date) return null
      const date = this.date.substring(0,10)
      const [year,month,day] = date.split('-')
      this.parsedDate = `${day.padStart(2, '0')}/${ENV.months[parseInt(month)].abv.toUpperCase()}/${year}`
      this.$emit('input', this.date)
    }
  },
  watch: {
      value(value) {
        if (value) {
          this.date = value.substring(0,10);
          this.parseInput(this.date)
        }
      }
  },
  props: ['value', 'label', 'disabled', 'rules', 'default', 'min'],
  data() {
    return {
        datePickerMenu: false,
        date: null,
        parsedDate: null,
    }
  }
}
</script>

<style>

</style>
